<div class="w-full">
  @if (!onlyCreateContact && !onlyEditContact) {
    <div class="flex flex-row gap-2 w-full justify-center my-4">
      <p-button
        icon="pi pi-plus"
        styleClass="text-sm"
        [label]="'contacts.addNewContact' | transloco"
        (click)="createNewContact()"
        [raised]="true"
      />
      <p-button
        icon="pi pi-search"
        styleClass="text-sm"
        [label]="'contacts.searchContact' | transloco"
        (click)="openSearchModal()"
        [raised]="true"
      />
      <p-button
        *ngIf="showForm || objectKeys(newContact).length"
        icon="pi pi-eraser"
        styleClass="text-sm"
        [label]="'contacts.clear' | transloco"
        (click)="clearContact()"
        [raised]="true"
      />
    </div>
  }
  <p-dialog
    [(visible)]="showSearchModal"
    [header]="'contacts.searchModalHeader' | transloco"
    [draggable]="false"
    [resizable]="false"
    [modal]="true"
    [style]="{ width: '100vw', height: '100vh' }"
    [contentStyle]="{ overflow: 'hidden' }"
    (onHide)="closeSearchModal()"
  >
    <ng-template pTemplate="closeicon">
      <span class="closeicon pi pi-times"></span>
    </ng-template>
    <ng-template pTemplate="header">
      <h3>{{ 'contacts.searchModalHeader' | transloco }}</h3>
    </ng-template>

    <div class="flex flex-row w-full justify-center mt-4 mb-2">
      <p-inputgroup>
        <input
          type="text"
          class="w-full"
          pInputText
          [(ngModel)]="searchTerm"
          [placeholder]="'contacts.searchPlaceholder' | transloco"
          (input)="onSearch()"
          spellcheck="false"
          autocomplete="off"
        />
        <p-inputgroup-addon>
          <p-button
            icon="pi pi-search"
            (click)="onSearch()"
            [disabled]="searchTerm.length < 2"
            class="h-[50px]"
          />
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>
    @if (contacts.length) {
      <div class="grow overflow-auto h-full">
        <p-table
          [value]="contacts"
          class="mt-4 h-full"
          stripedRows
          [scrollable]="true"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'contacts.company' | transloco }}</th>
              <th>{{ 'contacts.firstName' | transloco }}</th>
              <th>{{ 'contacts.lastName' | transloco }}</th>
              <th>{{ 'contacts.address' | transloco }}</th>
              <th>{{ 'contacts.birthday' | transloco }}</th>
              <th>{{ 'contacts.birthPlace' | transloco }}</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-contact>
            <tr>
              <td>{{ contact.companyName }}</td>
              <td>{{ contact.firstName }}</td>
              <td>{{ contact.lastName }}</td>
              <td>
                {{ contact.street || '' }}
                {{
                  contact.street && contact.city
                    ? ', ' + contact.city
                    : contact.city || ''
                }}
                {{
                  (contact.street || contact.city) && contact.zipCode
                    ? ', ' + contact.zipCode
                    : contact.zipCode || ''
                }}
              </td>
              <td>{{ contact.birthday | date: 'dd.MM.yyyy' }}</td>
              <td>{{ contact.birthPlace }}</td>
              <td class="flex flex-row-reverse">
                <p-button icon="pi pi-check" (click)="takeContact(contact)" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    } @else {
      <div class="flex flex-col items-center justify-center h-full p-4">
        <i class="pi pi-info-circle text-4xl mb-4"></i>
        <p class="text-lg">
          {{ 'contacts.noContactsFound' | transloco }}
        </p>
      </div>
    }
    <ng-template #footer>
      <div class="flex justify-end gap-2">
        <p-button
          icon="pi pi-times"
          label="{{ 'contacts.cancel' | transloco }}"
          (click)="closeSearchModal()"
          [text]="true"
        />
        <!-- Clear-Button im Such-Dialog zum Zurücksetzen von Eingabe + Ergebnissen -->
        <p-button
          icon="pi pi-eraser"
          styleClass="text-sm"
          [label]="'contacts.clear' | transloco"
          (click)="clearSearch()"
          [text]="true"
        />
        <p-button
          icon="pi pi-plus"
          label="{{ 'contacts.addNewContact' | transloco }}"
          (click)="closeSearchModal(); createNewContact()"
        />
      </div>
    </ng-template>
  </p-dialog>

  @if (validationError) {
    <div class="p-error">{{ validationError }}</div>
  }

  @if (showForm || objectKeys(newContact).length) {
    <div class="grid grid-cols-12 gap-2">
      <div class="col-span-3">
        <p-inputgroup>
          <p-iftalabel>
            <label for="contactGender">
              {{ 'contacts.gender' | transloco }}
            </label>

            @if (!editingDisabled) {
              <p-select
                class="p-inputdropdown-sm w-full"
                id="contactGender"
                [options]="personSalutationOptions"
                optionLabel="name"
                optionValue="value"
                [(ngModel)]="newContact.gender"
                (ngModelChange)="onInputChange()"
              />
            }
            @if (editingDisabled) {
              <input
                type="text"
                pInputText
                class="p-inputtext-sm w-full"
                id="contactGender"
                [value]="
                  newContact.gender
                    ? ('salutation.' + newContact.gender | transloco)
                    : ''
                "
                [disabled]="editingDisabled"
                [class.no-border]="editingDisabled"
              />
            }
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-3">
        <p-inputgroup>
          <p-iftalabel>
            <label for="contactTitle">
              {{ 'contacts.title' | transloco }}
            </label>

            @if (!editingDisabled) {
              <p-select
                class="p-inputdropdown-sm w-full"
                id="contactTitle"
                [options]="personTitleOptions"
                optionLabel="name"
                optionValue="value"
                [(ngModel)]="newContact.title"
                (ngModelChange)="onInputChange()"
              />
            }
            @if (editingDisabled) {
              <input
                type="text"
                pInputText
                class="p-inputtext-sm w-full"
                id="contactTitle"
                [value]="
                  newContact.title
                    ? ('title.' + newContact.title | transloco)
                    : ''
                "
                [disabled]="editingDisabled"
                [class.no-border]="editingDisabled"
              />
            }
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-6">
        <p-inputgroup>
          <p-iftalabel>
            <label for="contactFirstName">
              {{ 'contacts.firstName' | transloco }}
            </label>
            <input
              type="text"
              pInputText
              class="p-inputtext-sm w-full"
              id="contactFirstName"
              [(ngModel)]="newContact.firstName"
              (ngModelChange)="onInputChange()"
              [disabled]="editingDisabled"
              [class.no-border]="editingDisabled"
            />
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-6">
        <p-inputgroup>
          <p-iftalabel>
            <label for="contactLastName">
              {{ 'contacts.lastName' | transloco }}
            </label>
            <input
              type="text"
              pInputText
              class="p-inputtext-sm w-full"
              id="contactLastName"
              [(ngModel)]="newContact.lastName"
              (ngModelChange)="onInputChange()"
              [disabled]="editingDisabled"
              [class.no-border]="editingDisabled"
            />
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-12">
        <p-inputgroup>
          <p-iftalabel>
            <label for="contactCompanyName">
              {{ 'contacts.company' | transloco }}
            </label>

            <input
              type="text"
              pInputText
              class="p-inputtext-sm w-full"
              id="contactCompanyName"
              [(ngModel)]="newContact.companyName"
              (ngModelChange)="onInputChange()"
              [disabled]="editingDisabled"
              [class.no-border]="editingDisabled"
            />
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-5">
        <p-inputgroup>
          <p-iftalabel>
            <label for="contactStreet">
              {{ 'contacts.street' | transloco }}
            </label>
            <input
              type="text"
              pInputText
              class="p-inputtext-sm w-full"
              id="contactStreet"
              [(ngModel)]="newContact.street"
              (ngModelChange)="onInputChange()"
              [disabled]="editingDisabled"
              [class.no-border]="editingDisabled"
            />
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-3">
        <p-inputgroup>
          <p-iftalabel>
            <label for="contactZipCode">
              {{ 'contacts.zipCode' | transloco }}
            </label>
            <input
              type="text"
              pInputText
              class="p-inputtext-sm w-full"
              id="contactZipCode"
              [(ngModel)]="newContact.zipCode"
              (ngModelChange)="onInputChange()"
              [disabled]="editingDisabled"
              [class.no-border]="editingDisabled"
            />
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-4">
        <p-inputgroup>
          <p-iftalabel>
            <label for="contactCity">
              {{ 'contacts.city' | transloco }}
            </label>
            <input
              type="text"
              pInputText
              class="p-inputtext-sm w-full"
              id="contactCity"
              [(ngModel)]="newContact.city"
              (ngModelChange)="onInputChange()"
              [disabled]="editingDisabled"
              [class.no-border]="editingDisabled"
            />
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-12">
        <div class="flex flex-col w-full mt-2">
          @for (
            entry of newContact.phoneNumbers ?? [];
            track $index;
            let i = $index
          ) {
            <div class="mb-2 flex items-end gap-2 w-full">
              @if (!editingDisabled) {
                <div class="flex-1">
                  <p-iftalabel>
                    <label [for]="'phoneType_' + i">{{
                      'contacts.phoneType' | transloco
                    }}</label>
                    <p-select
                      class="w-full"
                      [id]="'phoneType_' + i"
                      [options]="phoneTypeOptions"
                      optionValue="value"
                      [(ngModel)]="entry.type"
                      [name]="'phoneType_' + i"
                      appendTo="body"
                      (ngModelChange)="onInputChange()"
                    >
                      <ng-template pTemplate="item" let-option>
                        {{ option.labelKey | transloco }}
                      </ng-template>

                      <ng-template pTemplate="selectedItem" let-option>
                        {{ option.labelKey | transloco }}
                      </ng-template>
                    </p-select>
                  </p-iftalabel>
                </div>
                <ng-container *transloco="let t">
                  <span class="hidden">
                    {{ t('contacts.mobileType') }}
                    {{ t('contacts.privateType') }}
                    {{ t('contacts.businessType') }}
                    {{ t('contacts.customType') }}
                  </span>
                </ng-container>
              }

              <div class="flex-[2]">
                <p-iftalabel>
                  @switch (entry.type) {
                    @case (phoneNumbersEntryType.MOBILE) {
                      <label [for]="'phoneNumber_' + i">
                        {{ 'contacts.mobileNumber' | transloco }}
                      </label>
                    }
                    @case (phoneNumbersEntryType.PRIVATE) {
                      <label [for]="'phoneNumber_' + i">
                        {{ 'contacts.privateNumber' | transloco }}
                      </label>
                    }
                    @case (phoneNumbersEntryType.BUSINESS) {
                      <label [for]="'phoneNumber_' + i">
                        {{ 'contacts.businessNumber' | transloco }}
                      </label>
                    }
                    @case (phoneNumbersEntryType.CUSTOM) {
                      <label [for]="'phoneNumber_' + i">
                        {{ 'contacts.privateNumber' | transloco }}
                      </label>
                    }
                    @default {
                      <label [for]="'phoneNumber_' + i">
                        {{ 'contacts.privateNumber' | transloco }}
                      </label>
                    }
                  }
                  <input
                    pInputText
                    class="w-full"
                    [id]="'phoneNumber_' + i"
                    [(ngModel)]="entry.number"
                    [name]="'phoneNumber_' + i"
                    [disabled]="editingDisabled"
                    [class.no-border]="editingDisabled"
                    (ngModelChange)="onInputChange()"
                    spellcheck="false"
                    autocomplete="off"
                  />
                </p-iftalabel>
              </div>

              <div class="flex-[2]">
                <p-iftalabel>
                  <label [for]="'phoneLabel_' + i">{{
                    'contacts.phoneLabel' | transloco
                  }}</label>
                  <input
                    pInputText
                    class="w-full"
                    [id]="'phoneLabel_' + i"
                    [(ngModel)]="entry.label"
                    [name]="'phoneLabel_' + i"
                    [disabled]="editingDisabled"
                    [class.no-border]="editingDisabled"
                    (ngModelChange)="onInputChange()"
                    spellcheck="false"
                    autocomplete="off"
                  />
                </p-iftalabel>
              </div>

              @if (!editingDisabled) {
                <p-button
                  icon="pi pi-trash"
                  styleClass="p-button-sm shrink-0"
                  class="self-center"
                  [rounded]="true"
                  severity="danger"
                  (click)="removePhoneNumber(i)"
                />
              }
            </div>
          }
        </div>
        <div class="flex items-center justify-between">
          @if (!editingDisabled) {
            <div class="flex items-center justify-between">
              <label>{{ 'contacts.addPhoneNumber' | transloco }}</label>

              @if (!editingDisabled) {
                <div class="flex items-center">
                  <p-button
                    icon="pi pi-plus"
                    class="p-button-text p-button-sm"
                    [text]="true"
                    (click)="addPhoneNumber()"
                  />
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="col-span-6">
        <p-inputgroup>
          <p-iftalabel>
            <label for="contactUrl">
              {{ 'contacts.url' | transloco }}
            </label>
            <input
              type="url"
              pInputText
              class="p-inputtext-sm w-full"
              id="contactUrl"
              [(ngModel)]="newContact.url"
              (ngModelChange)="onInputChange()"
              [disabled]="editingDisabled"
              [class.no-border]="editingDisabled"
            />
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-6">
        <p-inputgroup>
          <p-inputgroup-addon>
            @if (newContact.email) {
              <a
                class="text-(--p-primary-color)"
                [href]="'mailto:' + newContact.email"
                [pTooltip]="'animalAdd.origin.person.email' | transloco"
                tooltipPosition="top"
              >
                <i class="pi pi-envelope"></i>
              </a>
            } @else {
              <i class="pi pi-envelope"></i>
            }
          </p-inputgroup-addon>
          <p-iftalabel>
            <label for="contactEmail">
              {{ 'contacts.email' | transloco }}
            </label>
            <input
              type="text"
              pInputText
              class="p-inputtext-sm w-full"
              id="contactEmail"
              [(ngModel)]="newContact.email"
              (ngModelChange)="onInputChange()"
              [disabled]="editingDisabled"
              [class.no-border]="editingDisabled"
            />
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-4">
        @if (!editingDisabled) {
          <app-custom-date-picker
            [label]="'contacts.birthday'"
            [(ngModel)]="newContact.birthday"
            (ngModelChange)="onInputChange()"
            [rawInput]="formattedBirthday"
            [disabled]="editingDisabled"
          />
        }
        @if (editingDisabled) {
          <p-inputgroup>
            <p-iftalabel>
              <label for="dateOfReceipt">
                {{ 'contacts.birthday' | transloco }}
              </label>
              <input
                type="text"
                pInputText
                [value]="
                  newContact.birthday
                    ? (newContact.birthday | date: 'dd.MM.yyyy')
                    : ''
                "
                id="dateOfReceipt"
                disabled
              />
            </p-iftalabel>
          </p-inputgroup>
        }
      </div>
      <div class="col-span-4">
        <p-inputgroup>
          <p-iftalabel>
            <label for="contactBirthPlace">
              {{ 'contacts.birthPlace' | transloco }}
            </label>
            <input
              type="text"
              pInputText
              class="p-inputtext-sm w-full"
              id="contactBirthPlace"
              [(ngModel)]="newContact.birthPlace"
              (ngModelChange)="onInputChange()"
              [disabled]="editingDisabled"
              [class.no-border]="editingDisabled"
            />
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-4">
        <p-inputgroup>
          <p-iftalabel>
            <label for="contactIdCardNumber">
              {{ 'contacts.idCardNumber' | transloco }}
            </label>
            <input
              type="text"
              pInputText
              class="p-inputtext-sm w-full"
              id="contactIdCardNumber"
              [(ngModel)]="newContact.idCardNumber"
              (ngModelChange)="onInputChange()"
              [disabled]="editingDisabled"
              [class.no-border]="editingDisabled"
            />
          </p-iftalabel>
        </p-inputgroup>
      </div>
      <div class="col-span-6 flex gap-2 items-center">
        <p-toggleswitch
          name="contactIsVeterinary"
          inputId="contactIsVeterinary"
          [(ngModel)]="newContact.isVeterinary"
          (ngModelChange)="onInputChange()"
          [disabled]="editingDisabled"
        />
        <label for="contactIsVeterinary">
          {{ 'contacts.isVeterinary' | transloco }}
        </label>
      </div>
      <div class="col-span-6 flex gap-2 items-center">
        <p-toggleswitch
          name="contactNoNewAnimal"
          id="contactNoNewAnimal"
          [(ngModel)]="newContact.noNewAnimal"
          (ngModelChange)="onInputChange()"
          [disabled]="editingDisabled"
        />
        <label for="contactNoNewAnimal">
          {{ 'contacts.noNewAnimal' | transloco }}
        </label>
      </div>
    </div>
  }
</div>
